import { z } from 'zod';
import { NUTRIENT_KEYS } from '../nutrients.js';
/**
 * A nutrient amount as received from an untrusted source. Rejects negatives and
 * absurd values — a per-100 g row can never exceed 100 g of a macronutrient,
 * and 900 kcal/100 g is already past pure fat.
 */
const gramsPer100 = z.number().min(0).max(100);
const energyPer100 = z.number().min(0).max(1000);
/** Every nutrient present, with zeroes filled in for anything omitted. */
export const nutrientsSchema = z.object({
    kcal: energyPer100.default(0),
    protein: gramsPer100.default(0),
    carbs: gramsPer100.default(0),
    sugars: gramsPer100.default(0),
    fat: gramsPer100.default(0),
    saturated: gramsPer100.default(0),
    fiber: gramsPer100.default(0),
    salt: gramsPer100.default(0),
});
/** Same, but every key optional — for PATCH bodies and partial extractions. */
export const partialNutrientsSchema = nutrientsSchema.partial();
/** One nutrient by name, for marking provenance. */
export const nutrientKeySchema = z.enum(NUTRIENT_KEYS);
/**
 * Absolute (already-scaled) nutrient totals, which legitimately exceed the
 * per-100 g caps — eating 500 g of rice is more than 100 g of carbs.
 */
export const absoluteNutrientsSchema = z.object(Object.fromEntries(NUTRIENT_KEYS.map((key) => [key, z.number().min(0).default(0)])));
/** Whether a food's nutrient row is stated per 100 g or per 100 ml. */
export const nutritionBasisSchema = z.enum(['per_100g', 'per_100ml']);
//# sourceMappingURL=nutrients.js.map